import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import EditableTables from "../../pages/Tables/EditableTables"
import UiButtons from "../../pages/Ui/UiButtons"
import _valid from "../../validations"
import cellEditFactory, { Type } from "react-bootstrap-table2-editor"
import MaterialTable from 'material-table'
import { Button } from "bootstrap";
import { Asignado_Estados, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";
import { Edit, SkipNext, SkipPrevious } from '@material-ui/icons';
import SweetAlert from "react-bootstrap-sweetalert";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import UpdateIcon from '@material-ui/icons/Update';


const columns = [
    {
        title: "#",
        field: "id"
    },
    {
        title: "Articulo",
        field: "articulo.articulo"
    },
    {
        title: "fecha asignado",
        field: "fecha"
    },
    {
        title: "Departamento",
        field: "departamento.departamentoTexto"
    },
    {
        title: "Area",
        field: "departamento.area"
    },
    {
        title: "Estado",
        field: "estadoLabel"
    },
    {
        title: "Entregado a",
        field: "colaborador.label"
    },
    {
        title: "Cantidad",
        field: "cantidad"
    }
];

export default class listaAsignado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        props = _valid(props, props.props) ? props.props : props;
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
            },
            //data a mostrar
            data: [],
            departamentoAreas: [],
            consulta: {
                fechaFin: null,
                fechaMin: null,
                area: null,
                estado: null
            },
            timeralert: null,
        };
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
    }

    componentDidMount() {

        if (_valid(this.state.registro.id)) {
            let id = this.state.registro.id
            this.cargarListado(id);
        }
        this.obtenerDepartamentos();
    }

    //obtener area departamento
    obtenerDepartamentos() {
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //formato a valores de area
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    //set nombre area
    setArea = asignado => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, ['area']: asignado }
        }));
    }

    cancelar = () => {
        this.setState({ timeralert: null })
    }

    confirmar = async (registro) => {
        this.apiRest.delete('/deleteAsignado/' + registro.id).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Registro Borrado con Exito.');
                let dataDelete = [];
                dataDelete = this.state.data;
                const index = registro.tableData.id;
                if (index === 0) {
                    this.setState({ data: [] });
                } else {
                    dataDelete.splice(index, 1);
                    this.setState({ data: [] });
                    this.setState({ data: dataDelete });
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
        this.cancelar();
    }

    ventanaEmergente = (registro) => {
        const nextmsg = () => (
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Eliminar"
                cancelBtnText="Cancelar"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                title="Eliminar"
                onCancel={() => this.cancelar()}
                onConfirm={() => this.confirmar(registro)}
            >
                Esta seguro de borrar el Registro: {registro.id}.<br></br>
            </SweetAlert>
        )
        this.setState({ timeralert: nextmsg() })
    }

    cargarListado = (id) => {
        this.apiRest.get('/getAsignado/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ data: resultado.data });
            }
        });
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            consulta: { ...estadoAnterior.consulta, [name]: value }
        }));
    }

    abrirModal = () => {
        this.setState({ modalModificar: true });
    }

    cerrarModal = () => {
        this.setState({ modalModificar: false })
    }

    buscar = async () => {
        const {
            consulta
        } = this.state

        if (this.verificar(consulta)) {
            this.apiRest.put('/filtrarAsignados', consulta).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ data: resultado.data })
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            toastr.error('Seleccione un filtro por favor');
        }
    }

    verificar = (data) => {
        let contador = 0;
        if (_valid(data.fechaMin)) {
            if (_valid(data.fechaFin)) {
                contador += 1;
            }
        } else if (_valid(data.area)) {
            contador += 1;
        } else if (_valid(data.estado)) {
            contador += 1;
        }

        if (contador !== 0) {
            return true;
        } else {
            return false;
        }
    }

    editar = (e, registro) => {
        this.props.history.replace({ pathname: '/editarAsignado', registro: registro });
    }

    eliminarRegistro = (e, registro) => {
        this.ventanaEmergente(registro);
    }

    render() {
        const {
            departamentosAreas,
            consulta
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        {this.state.timeralert}
                        <Breadcrumbs title="Listado de Articulos Asignados" breadcrumbItem={"Listado"} />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={6}>
                                                <Label htmlFor="area" className="form-label">
                                                    Área
                                                </Label>
                                                <Select
                                                    name="area"
                                                    options={departamentosAreas}
                                                    value={consulta.area}
                                                    onChange={this.setArea}
                                                />
                                            </Col>
                                            {' '}
                                            <Col lg={6}>
                                                <Label htmlFor="estado" className="form-label">
                                                    Estado
                                                </Label>
                                                <select
                                                    value={consulta.estado}
                                                    onChange={this.actualizarValores}
                                                    name="estado"
                                                    className="form-control"
                                                >
                                                    {Asignado_Estados.map(objeto => <option key={objeto.value} value={objeto.value}>{objeto.label}</option>)}
                                                </select>
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={4}>
                                                <Label htmlFor="fechaMin" className="form-label">
                                                    Fecha inicial
                                                </Label>
                                                <Input
                                                    value={consulta.fechaMin}
                                                    onChange={this.actualizarValores}
                                                    name="fechaMin"
                                                    type="date"
                                                />
                                            </Col>
                                            {' '}
                                            <Col lg={4}>
                                                <Label htmlFor="fechaFin" className="form-label">
                                                    Fecha fin
                                                </Label>
                                                <Input
                                                    value={consulta.fechaFin}
                                                    onChange={this.actualizarValores}
                                                    name="fechaFin"
                                                    type="date"
                                                />
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={3}>
                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                    Buscar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                        <p />
                                        <Row>
                                            <MaterialTable
                                                keyField="id"
                                                title="Lista de Articulos Asignados"
                                                columns={columns}
                                                data={this.state.data}
                                                actions={[
                                                    {
                                                        icon: UpdateIcon,
                                                        tooltip: 'Editar',
                                                        onClick: (event, rowData) => this.editar(event, rowData)
                                                    },
                                                    {
                                                        icon: DeleteForeverIcon,
                                                        tooltip: 'Eliminar',
                                                        onClick: (event, rowData) => this.eliminarRegistro(event, rowData)
                                                    }
                                                ]}
                                                options={
                                                    {
                                                        search: false,
                                                        pageSize: 2,
                                                        pageSizeOptions: [5, 10, 25],
                                                        showFirstLastPageButtons: false,
                                                    }
                                                }
                                                localization={
                                                    {
                                                        header: { actions: 'Editar' },
                                                        pagination: {
                                                            labelRowsSelect: 'Filas',
                                                            labelDisplayedRows: "{from}-{to} de {count}",
                                                            nextTooltip: "Siguiente Pagina",

                                                            previousTooltip: "Anterior Pagina"
                                                        }
                                                    }
                                                }
                                                icons={
                                                    {
                                                        NextPage: SkipNext,
                                                        PreviousPage: SkipPrevious
                                                    }
                                                }
                                            />
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={12} className="text-end">
                                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/articuloAsignar') }}>
                                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                    Regresar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}